// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"ce1777ec","147":"c60299eb","304":"c1772a5c","667":"834da2e4","727":"6ec5f305","975":"b0db34ef"}[chunkId] + ".css";
};